module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('strong', [_vm._v("We Are the Forgotten")])])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "poem-linet"
  }, [_vm._v("We are the old, the unremembered dead.")]), _vm._v(" "), _c('p', {
    staticClass: "poem-line"
  }, [_vm._v("Forgot, we lie in country graveyards high on lonely hills.")]), _vm._v(" "), _c('p', {
    staticClass: "poem-line"
  }, [_vm._v("We are unwept save by such tears as sheds,")]), _vm._v(" "), _c('p', {
    staticClass: "poem-line"
  }, [_vm._v("The weeping sky.")]), _vm._v(" "), _c('p', {
    staticClass: "poem-linet"
  }, [_vm._v("Above old huddled graves in city streets, sometimes a passer finds,")]), _vm._v(" "), _c('p', {
    staticClass: "poem-line"
  }, [_vm._v("The time to pause and sigh remembering.")]), _vm._v(" "), _c('p', {
    staticClass: "poem-line"
  }, [_vm._v("But none pass by us here,")]), _vm._v(" "), _c('p', {
    staticClass: "poem-line"
  }, [_vm._v("Above us sigh only the winds.")]), _vm._v(" "), _c('p', {
    staticClass: "poem-linet"
  }, [_vm._v("The hands that laid us here long, long ago are dust.")]), _vm._v(" "), _c('p', {
    staticClass: "poem-line"
  }, [_vm._v("The impassioned tears shed then for us are dried.")]), _vm._v(" "), _c('p', {
    staticClass: "poem-line"
  }, [_vm._v("The faltering feet that followed us in grief have now lain still,")]), _vm._v(" "), _c('p', {
    staticClass: "poem-line"
  }, [_vm._v("Unnumbered years.")]), _vm._v(" "), _c('p', {
    staticClass: "poem-linet"
  }, [_vm._v("And, strange hands now till the fields we cleared.")]), _vm._v(" "), _c('p', {
    staticClass: "poem-line"
  }, [_vm._v("Strange voices ring beneath the roofs we raised.")]), _vm._v(" "), _c('p', {
    staticClass: "poem-line"
  }, [_vm._v("Beneath the trees we planted, strange young lovers make their vows,")]), _vm._v(" "), _c('p', {
    staticClass: "poem-line"
  }, [_vm._v("Each passing spring.")]), _vm._v(" "), _c('p', {
    staticClass: "poem-linet"
  }, [_vm._v("The alien plow that draws so near…so near.")]), _vm._v(" "), _c('p', {
    staticClass: "poem-line"
  }, [_vm._v("Disturbs our rest.")]), _vm._v(" "), _c('p', {
    staticClass: "poem-line"
  }, [_vm._v("Here in our sunken and neglected graves we stir.")]), _vm._v(" "), _c('p', {
    staticClass: "poem-line"
  }, [_vm._v("Who will protest?")]), _vm._v(" "), _c('p', {
    staticClass: "poem-linet"
  }, [_vm._v("We are unclamoring.")]), _vm._v(" "), _c('p', {
    staticClass: "poem-line"
  }, [_vm._v("We only ask that we may lie,")]), _vm._v(" "), _c('p', {
    staticClass: "poem-line"
  }, [_vm._v("Safe from the plow that threatens our old graves,")]), _vm._v(" "), _c('p', {
    staticClass: "poem-line"
  }, [_vm._v("Covered by vines, mourned by the passing winds,")]), _vm._v(" "), _c('p', {
    staticClass: "poem-line"
  }, [_vm._v("Wept by the sky.")]), _vm._v(" "), _c('p', {
    staticClass: "poem-author"
  }, [_vm._v("Anonymous")]), _vm._v(" "), _c('p', {
    staticClass: "poem-author0"
  }, [_vm._v("Possibly written by Ossie Glenn")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b53108b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004_FM01.vue
// module id = 66
// module chunks = 0